module.exports = __webpack_public_path__ + "img/crime.ed1a2949.png";